import { Component, ErrorInfo, ReactNode, useEffect, useState } from 'react';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import database from "./database.json";
import { getEdges, getMaterials } from './stolarz-form/database_helpers';
import { DatabaseView } from "./database-view/database_view";
// import { Explanations } from "./problems/explanations";
import { StolarzForm } from './stolarz-form/StolarzForm';
import { DBSchema, DBMaterialType } from "./database_types";
import { Container, Nav, Navbar } from 'react-bootstrap';
import { HomeScreen } from './HomeScreen';
import { StolarzFormModify } from './stolarz-form/StolarzFormModify';


// function CookieAcceptToast() {
//     const [show, setShow] = useState(true);

//     return (
//         <Row style={{ position: "fixed", bottom: 0, right: 0, zIndex: 17 }} className="m-5">
//             <Col>
//                 <Toast onClose={() => setShow(false)} show={show} >
//                     <Toast.Body>
//                         {/* <p>
//                             Strona internetowa stolarz.net.pl korzysta z plików cookie. Dzięki temu możemy zapewnić naszym użytkownikom satysfakcjonujące wrażenia z przeglądania naszej witryny i jej prawidłowe funkcjonowanie.
//                             <a href="https://stolarz.net.pl/upload/1557392275polityka-strona_stolarz.pdf">Czytaj więcej...</a>
//                         </p> */}
//                         {/* <p>Ta strona nie używa plikó cookie</p> */}
//                         <Container>
//                             <Row >
//                                 <Button onClick={() => setShow(false)}>Ok</Button>
//                             </Row>
//                         </Container>
//                     </Toast.Body>
//                 </Toast>
//             </Col>
//         </Row>
//     );
// }
interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> { // not sure how it works...
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        // if (this.state.hasError) { // todo just ignore error? hopefully it will not break the app...
        //     return <h1>Sorry.. there was an error</h1>;
        // }

        return this.props.children;
    }
}
function App() {
    const [materials, setMaterials] = useState<DBMaterialType[]>([])
    const [edges, setEdges] = useState<DBMaterialType[]>([])

    useEffect(() => {
        const db = database;
        let validatedDb = DBSchema.parse(db);
        setMaterials(getMaterials(validatedDb));
        setEdges(getEdges(validatedDb));
    }, []);
    const router = createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route path="/" element={<HomeScreen />} />
                <Route path="/zamowienie" element={
                    <ErrorBoundary>
                        <StolarzForm materialsDB={materials} edgesDB={edges} isModyfingExistingOrder={false}></StolarzForm>
                    </ErrorBoundary>
                } />
                <Route path="/zamowienie-aktualizacja" element={<StolarzForm materialsDB={materials} edgesDB={edges} isModyfingExistingOrder={true}></StolarzForm>} />
                {/* <Route path="/zamowienie-aktualizacja" element={<StolarzFormModify materialsDB={materials} edgesDB={edges}></StolarzFormModify>} /> */}
                <Route path="/spis" element={<DatabaseView materials={materials} edges={edges}></DatabaseView>} />
                {/* <Route path="/tutorial" element={<Explanations></Explanations>} /> */}
            </>
        )
    );
    return (
        <div className="App">
            <Navbar bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand href="./#">
                        <img alt="" src="./favicon.ico" width="30" height="30" className="d-inline-block align-top" />
                        {' '}Formatki FPHU Stolarz Piotr Grzeliński
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="./spis">
                                Spis materiałów
                            </Nav.Link>
                        </Nav>
                        <Nav >
                            <Nav.Link disabled >Baza danych z 24.10.2023</Nav.Link>
                        </Nav>
                        <Nav>
                            <Nav.Link href="http://www.stolarz.net.pl">
                                Wróć na stolarz.net.pl
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container>
                {/* <CookieAcceptToast></CookieAcceptToast> */}
                <RouterProvider router={router} />
            </Container>

            <footer className="page-footer font-small blue pt-4">
                <div className="footer-copyright text-center py-3">
                    <p >Wszystkie prawa zastrzeżone dla FPHU Stolarz Piotr Grzeliński | {" "}
                        <a href="https://stolarz.net.pl/upload/1557392275polityka-strona_stolarz.pdf" target="_blank" rel="noopener noreferrer">Polityka prywatności</a> | {" "}
                        <a className="footer_link_style" href="https://stolarz.net.pl/p/aktualnosci" title="Aktualności">Aktualności</a> | {" "}
                        <a className="footer_link_style" href="https://stolarz.net.pl/p/uslugi" title="Usługi">Usługi</a> |{" "}
                        <a className="footer_link_style" href="https://stolarz.net.pl/p/referencje" title="Referencje">Referencje</a> | {" "}
                        <a className="footer_link_style" href="https://stolarz.net.pl/p/wpis/meble-lubin/9" title="Meble Lubin - sprawdź">Meble Lubin</a>
                    </p>
                </div>
            </footer>

        </div>
    );
}

export default App;
